import React from 'react'
import { Route, NavLink, Switch, withRouter, Link, Redirect } from 'react-router-dom'
import {isLogin, login, logout} from '../../utils/index'

import Home from '../Home';
import Account from '../../components/account/Account';
import Address from '../../components/account/Address';
import ChangePassword from '../../components/account/ChangePassword';
import Wishlist from '../../components/account/Wishlist';
import Reviews from '../../components/account/Reviews';
import Orders from '../../components/account/Orders';
import OrdersTrack from '../../components/account/OrdersTrack';

import PrivateRoute from '../../components/route/PrivateRoute';

class AuthorizedLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }   
  }

  render() {
    return (
      <>
          <Switch>
                <PrivateRoute component={Account} path="/account" exact />
                <PrivateRoute component={Address} path="/address" exact />
                <PrivateRoute component={ChangePassword} path="/password" exact />
                <PrivateRoute component={Wishlist} path="/wishlist" exact />
                <PrivateRoute component={Reviews} path="/reviews" exact />
                <PrivateRoute component={Orders} path="/orders" exact />
                <PrivateRoute component={OrdersTrack} path="/trackorders" exact />
                {/* <Route exact path="/account" component={Account}/>
                <Route exact path="/address" component={Address}/>
                <Route exact path="/changepassword" component={ChangePassword}/>
                <Route exact path="/wishlist" component={Wishlist}/>
                <Route exact path="/reviews" component={Reviews}/>
                <Route exact path="/orders" component={Orders}/>
                <Route exact path="/orderstrack" component={OrdersTrack}/> */}
            </Switch>
      </>

    );
  }
}

export default AuthorizedLayout;

